import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=3cfd9c47&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=3cfd9c47&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfd9c47",
  null
  
)

export default component.exports